import type { PropsWithChildren } from "react"
import React from "react"

import ViewObserverContainer from "~components/shared/todo-lib-react-components/view-observer-container"

interface Props extends PropsWithChildren {
    readonly isMobile: boolean
    readonly fetchMore: () => void
    readonly canFetchMore?: boolean
    readonly isLastComponent: boolean
}

export default function ActivityCardWrapper({
    isMobile,
    fetchMore,
    canFetchMore,
    isLastComponent,
    children,
}: Props) {
    // need to wrap in fragment to make typescript happy
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!isMobile || !canFetchMore || !isLastComponent) return <>{children}</>

    return (
        // added delay which matches the time it takes for the sliding animation to finish otherwise the slide apears to be stuck halfway through it
        <ViewObserverContainer onViewed={fetchMore} delay={500}>
            {children}
        </ViewObserverContainer>
    )
}
